"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _buttonNext = require("wix-ui-core/dist/src/components/button-next");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _generateDataAttr = require("../utils/generateDataAttr");

var _IconButtonSt = require("./IconButton.st.css");

var _excluded = ["skin", "className", "priority", "size", "children", "dataHook", "ariaLabel", "ariaLabelledBy"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IconButton = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(IconButton, _PureComponent);

  var _super = _createSuper(IconButton);

  function IconButton(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, IconButton);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
      _this.button.current && _this.button.current.focus();
    });
    _this.button = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  /**
   * Sets focus on the button element
   */


  (0, _createClass2["default"])(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          skin = _this$props.skin,
          className = _this$props.className,
          priority = _this$props.priority,
          size = _this$props.size,
          children = _this$props.children,
          dataHook = _this$props.dataHook,
          ariaLabel = _this$props.ariaLabel,
          ariaLabelledBy = _this$props.ariaLabelledBy,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var childSize = _constants.iconChildSize[size];
      return /*#__PURE__*/_react["default"].createElement(_buttonNext.ButtonNext, (0, _extends2["default"])({}, rest, {
        ref: this.button,
        className: (0, _IconButtonSt.st)(_IconButtonSt.classes.root, {
          skin: skin,
          priority: priority,
          size: size
        }, className)
      }, (0, _generateDataAttr.generateDataAttr)(this.props, ['skin', 'priority', 'size']), {
        "data-hook": dataHook,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
      }), children && /*#__PURE__*/_react["default"].cloneElement(children, {
        size: childSize,
        width: childSize,
        height: childSize
      }));
    }
  }]);
  return IconButton;
}(_react.PureComponent);

(0, _defineProperty2["default"])(IconButton, "displayName", 'IconButton');
(0, _defineProperty2["default"])(IconButton, "propTypes", {
  /** render as some other component or DOM tag */
  as: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].string]),

  /** Classes to be applied to the root element */
  className: _propTypes["default"].string,

  /** Used for passing any wix-style-react icon. For external icon make sure to follow ux sizing guidelines */
  children: _propTypes["default"].node,

  /** Button skins */
  skin: _propTypes["default"].oneOf(['standard', 'inverted', 'light', 'transparent', 'premium']),

  /** Button priority */
  priority: _propTypes["default"].oneOf(['primary', 'secondary']),

  /** Button size */
  size: _propTypes["default"].oneOf(['tiny', 'small', 'medium', 'large']),

  /** Click event handler  */
  onClick: _propTypes["default"].func,

  /** Applies disabled styles */
  disabled: _propTypes["default"].bool,

  /** String based data hook */
  dataHook: _propTypes["default"].string,

  /** Defines a string value that labels the button element */
  ariaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the button element */
  ariaLabelledBy: _propTypes["default"].string
});
(0, _defineProperty2["default"])(IconButton, "defaultProps", {
  skin: 'standard',
  priority: 'primary',
  size: 'medium',
  disabled: false
});
var _default = IconButton;
exports["default"] = _default;